import { ADD_CAR_DETAIL, SEARCH_CARS, FETCH_ALL_CAR_DETAILS, UPDATE_CAR_DETAIL, ADD_PROFORMA_INVOICE_TO_CARDETAIL, DELETE_CAR, ADD_AGREEMENT_TO_CARDETAIL, ADD_REPROCESSING_TO_CARDETAIL, RESET } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate:{}}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_CAR_DETAIL:
            return { ...state ,data: { ...state.data, [action.payload.id]:action.payload  }}
        case FETCH_ALL_CAR_DETAILS:
            const paginate = _.omit(action.payload, 'data');
            return {...state, data:_.mapKeys(action.payload.data, 'id'), paginate}
        case SEARCH_CARS:
            return {...state, data:_.mapKeys(action.payload.data, 'id')}
        case UPDATE_CAR_DETAIL:
            return { ...state, data: { ...state.data, [action.payload.id]:action.payload }  }
        case DELETE_CAR:
            return {...state, data:_.omit(state.data, action.payload)};
        case ADD_PROFORMA_INVOICE_TO_CARDETAIL:
            return { ...state , data:{ ...state.data, [action.payload.id]:action.payload } }
        case ADD_REPROCESSING_TO_CARDETAIL:
            return { ...state , data:{ ...state.data, [action.payload.id]:action.payload } }
        case ADD_AGREEMENT_TO_CARDETAIL:
            return { ...state , data:{ ...state.data, [action.payload.id]:action.payload } }
        case RESET:
            return INITIAL_STATE
        default:
            return state;
    }
}